import { render, staticRenderFns } from "./AtividadesComentarios.vue?vue&type=template&id=667afb6b&scoped=true"
import script from "./AtividadesComentarios.vue?vue&type=script&lang=js"
export * from "./AtividadesComentarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667afb6b",
  null
  
)

export default component.exports